import * as React from "react";
import Guide from "../../../../components/Guide";
import { api } from "../../../../components/helpers";
import Layout from "../../../../components/layouts/DatoGuidesLayout";
import Head from "next/head";

   
export async function getStaticPaths() {
    const guides = await api.get_all_dato_guides();

    const paths = guides.data.allGuides.filter((x) => x.grouping !== "increment")
        .filter((x) => x._status === "published")
        .map((x) => {
            return { params: { slug: x.slug } };
        });

    return {
        paths: paths,
        fallback: false
    };
}

export async function getStaticProps({ params }) {
    const guide = await api.get_dato_guide(params.slug);
    const post = guide.data.guide;

    return {
        props: {
            post,
            params,
            component: "Guide"
        },
    };
}

function ensureTrailingSlash(str) {
    if (str.charAt(str.length - 1) !== '/') {
        str += '/';
    }
    return str;
}

export default function GuidePage({ user, mobileMenuIsOpen, setMobileMenu, handleToast, post }) {
    return <><Head><link
        rel="canonical"
        href={ensureTrailingSlash(`https://www.covalenthq.com/docs/unified-api/guides/${post.slug}`)}
        key="canonical" /></Head><Layout user={user} mobileMenuIsOpen={mobileMenuIsOpen} setMobileMenu={setMobileMenu} handleToast={handleToast} post={post}><Guide
        post={post} /></Layout></>;
}
